import { useCallback } from 'react';
import { useDisclosure } from '../../../shared/hooks/use-disclosure';
import { useActiveLedger, useSwitchLedger } from './use-active-ledger';

export function useLedgerSwitcher() {
  const { ledger, ledgers, isLoading } = useActiveLedger();
  const { switchTo, isSwitching } = useSwitchLedger();
  const { isOpen, containerRef, toggle, close } = useDisclosure<HTMLDivElement>();

  const choose = useCallback(
    (ledgerId: string) => {
      close();
      if (ledgerId !== ledger?.id) switchTo(ledgerId);
    },
    [close, ledger?.id, switchTo],
  );

  return { active: ledger, ledgers, isLoading, isSwitching, isOpen, containerRef, toggle, close, choose };
}
